import { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './contexts/AuthContext';
import { app } from './config/firebase';
import { trackPageView, trackEvent } from './utils/analytics';
import './App.css';

// Lazy load pages
const HomePage = lazy(() => import('./pages/HomePage'));
const CreateOrganizationPage = lazy(() => import('./pages/CreateOrganizationPage'));
const OrganizationListPage = lazy(() => import('./pages/OrganizationListPage'));
const OrganizationDetailPage = lazy(() => import('./pages/OrganizationDetailPage'));
const NotificationTestPage = lazy(() => import('./pages/NotificationTestPage'));
const UserProfileViewPage = lazy(() => import('./pages/UserProfileViewPage'));
const UsernameReservationPage = lazy(() => import('./pages/UsernameReservationPage'));

function AppContent() {
  useEffect(() => {
    // Firebase is now initialized and ready to use
    console.log('Firebase initialized:', app.name);

    // Track initial page view
    trackPageView('home', 'EZUnity Homepage');

    // Track app initialization
    trackEvent('app_initialized', {
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent,
    });
  }, []);

  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Suspense fallback={<div className="loading">Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/o" element={<OrganizationListPage />} />
              <Route path="/o/:slug" element={<OrganizationDetailPage />} />
              <Route path="/create-organization" element={<CreateOrganizationPage />} />
              <Route path="/u/:username" element={<UserProfileViewPage />} />
              <Route path="/username" element={<UsernameReservationPage />} />
              <Route path="/test/notifications" element={
                <AdminRoute>
                  <NotificationTestPage />
                </AdminRoute>
              } />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
